export const BRAND = {
  name: "Mask Giver",
  short: "MG",
  mission: "Saving one soul at a time",
  cover:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_5359fb2a-885c-4920-adee-59fd53fc140a/artifacts/b0nkpeqe_Mask%20Giver%20page%20cover-2.jpg",
};

export const HERO_IMAGE =
  "https://images.pexels.com/photos/9532269/pexels-photo-9532269.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600";

export const STATS = [
  { value: 12400, suffix: "+", label: "Meals served" },
  { value: 3200, suffix: "+", label: "Clothes & shoes given" },
  { value: 48, suffix: "", label: "Outreach missions" },
  { value: 150, suffix: "+", label: "Volunteers on the ground" },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "We show up",
    body:
      "Every week our team walks the streets others walk past. No cameras needed, no applause — just presence. We meet people where they are, learn their names, and remind them they are seen.",
  },
  {
    n: "02",
    title: "We give what's needed",
    body:
      "Hot meals, cold water, fresh juice, warm clothes and shoes that actually fit. Dignity isn't a slogan for us — it's a plate handed over with two hands and eye contact.",
  },
  {
    n: "03",
    title: "We come back",
    body:
      "Change isn't a one-time drop-off. We return to the same corners, the same faces, building trust one visit at a time until a soul knows it is never forgotten.",
  },
];

export const GALLERY = [
  {
    src: "https://images.pexels.com/photos/9532269/pexels-photo-9532269.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    alt: "A volunteer offering a warm meal to a man on the street",
    span: "md:col-span-7 md:row-span-2",
    tag: "Feeding",
  },
  {
    src: "https://images.pexels.com/photos/6995247/pexels-photo-6995247.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=900",
    alt: "Team packing food boxes for distribution",
    span: "md:col-span-5",
    tag: "Meal packs",
  },
  {
    src: "https://images.unsplash.com/photo-1462927114214-6956d2fddd4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Shoes lined up to be given away",
    span: "md:col-span-5",
    tag: "Shoes",
  },
  {
    src: "https://images.unsplash.com/photo-1780764818930-cc608bb271e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Clothes and shoes laid out for those in need",
    span: "md:col-span-4",
    tag: "Clothing",
  },
  {
    src: "https://images.unsplash.com/photo-1593113616828-6f22bca04804?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Bags of food handed out at an outreach line",
    span: "md:col-span-4",
    tag: "Water & juice",
  },
  {
    src: "https://images.unsplash.com/photo-1461532257246-777de18cd58b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Two hands meeting — a moment of human connection",
    span: "md:col-span-4",
    tag: "Dignity",
  },
  {
    src: "https://images.pexels.com/photos/36763231/pexels-photo-36763231.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    alt: "Reaching a man holding a sign on the sidewalk",
    span: "md:col-span-7",
    tag: "On the streets",
  },
  {
    src: "https://images.unsplash.com/photo-1599059813005-11265ba4b4ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Volunteers sorting canned food donations",
    span: "md:col-span-5",
    tag: "Behind the scenes",
  },
];

export const DONATION_PRESETS = [10, 25, 50, 100];

export const PAYMENT_HANDLES = {
  zelle: "give@maskgiver.com",
  cashapp: "$MaskGiver1",
};
